export default "__VITE_ASSET__BiIXRZ2C__"